import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { CheckboxOption } from './CheckboxOption';
/**
 * @deprecated
 */

export var CheckboxBlock = /*#__PURE__*/React.forwardRef(function (props, ref) {
  useDeprecatedComponentWarning({
    component: 'CheckboxBlock',
    migration: 'Use <CheckboxOption> directly instead.'
  });
  return /*#__PURE__*/React.createElement(CheckboxOption, _extends({
    ref: ref
  }, props, {
    inline: false
  }));
});
CheckboxBlock.displayName = 'CheckboxBlock';